import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { CollaboratorFunction } from './types'

export const CREATE_COLLABORATOR_FUNCTION: TypedDocumentNode<
  { createCollaboratorFunction: CollaboratorFunction },
  { client_id: string; application_id: string; name: string }
> = gql`
  mutation CreateCollaboratorFunction($client_id: ID!, $application_id: ID!, $name: String!) {
    createCollaboratorFunction(client_id: $client_id, application_id: $application_id, name: $name) {
      id client_id application_id key name locked collaborators_count created_at updated_at
    }
  }
`

export const UPDATE_COLLABORATOR_FUNCTION: TypedDocumentNode<
  { updateCollaboratorFunction: CollaboratorFunction },
  { id: string; name: string }
> = gql`
  mutation UpdateCollaboratorFunction($id: ID!, $name: String!) {
    updateCollaboratorFunction(id: $id, name: $name) {
      id client_id application_id key name locked collaborators_count created_at updated_at
    }
  }
`

export const DELETE_COLLABORATOR_FUNCTION: TypedDocumentNode<
  { deleteCollaboratorFunction: boolean },
  { id: string }
> = gql`
  mutation DeleteCollaboratorFunction($id: ID!) {
    deleteCollaboratorFunction(id: $id)
  }
`
